import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c84547"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-slateGray" }
const _hoisted_2 = { class: "text-card" }
const _hoisted_3 = { class: "text-card relative text-stone text-center hidden sm:block sm:text-body2xl top-24 sm:top-1/3" }

import { computed, onMounted, reactive, watch } from 'vue'
import { MJPSection, MJPSectionData } from './types'
import SectionBase from '../general/SectionBase.vue'
import SectionPage from '../general/SectionPage.vue'
import TextCard from '../general/TextCard.vue'
import useLanguage from '@/composables/useLanguage'
import { useEventBus } from '@vueuse/core'
import { useSettingsStore } from '@/store/settings'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'
import BottomGradient from '../general/BottomGradient.vue'
import timelineData from '@/assets/data/mjp/timeline-data.js'
import SiteTimeline from '../general/SiteTimeline.vue'
import ChevronDown from '@/assets/svg/ChevronDown.vue'

interface Props {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistorySection',
  props: {
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    forward: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


const sectionText = useLanguage('history')
const interfaceText = useLanguage('interface')
const settingsStore = useSettingsStore()
const popoverOpenedBus = useEventBus('popover-opened')
const popoverClosedBus = useEventBus('popover-closed')
const hotspotClickedBus = useEventBus('hotspot-clicked')
const state = reactive({
  popoverIsOpen: false,
})

popoverOpenedBus.on(() => {
  state.popoverIsOpen = true
})

popoverClosedBus.on(() => {
  state.popoverIsOpen = false
})

hotspotClickedBus.on((index) => {
  if (index == -1) {
    state.popoverIsOpen = false
  }
})

const sectionIsActive = computed(() => {
  return props.currentSection == props.sectionData.section
})

const pageRangeIsActive = (lo, hi) => {
  if (sectionIsActive.value && props.currentSectionHasLoaded) {
    return props.currentPage >= lo && props.currentPage <= hi
  } else {
    return false
  }
}

const focusCurrentTextCard = () => {
  ;(
    document.querySelector(
      `#${props.currentSection}-${props.currentPage + 1} .text-card`
    ) as HTMLElement
  )?.focus()
}

onMounted(() => {
  focusCurrentTextCard()
})

watch(
  () => props.currentPage,
  (currentValue, previousValue) => {
    focusCurrentTextCard()
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveBackgroundImage, {
      id: "whereAreWe-bg",
      dir: "mjp",
      sm: "whereAreWe-bg-sm.jpg",
      md: "whereAreWe-bg-md.jpg",
      lg: "whereAreWe-bg-lg.jpg",
      alt: _unref(sectionText).willowbrookAlt,
      isActive: pageRangeIsActive(0, 0)
    }, null, 8, ["alt", "isActive"]),
    _createVNode(ResponsiveBackgroundImage, {
      id: "history-bg",
      dir: "mjp",
      sm: "history-bg-sm.jpg",
      md: "history-bg-sm.jpg",
      alt: _unref(sectionText).altText,
      isActive: pageRangeIsActive(1, 1)
    }, null, 8, ["alt", "isActive"]),
    _createElementVNode("div", {
      class: _normalizeClass(["none xl:absolute right-[280px] bottom-50px rounded-[10px] px-5 py-10px text-stone-dark-95 text-bodyMd", {
        'bg-slateGray': _unref(settingsStore).highContrast,
        hidden: !pageRangeIsActive(1, 1),
      }])
    }, _toDisplayString(_unref(sectionText).photoCredit), 3),
    _createVNode(BottomGradient),
    _createVNode(SectionBase, {
      thisSection: props.sectionData.section,
      currentSection: props.currentSection,
      currentSectionHasLoaded: props.currentSectionHasLoaded,
      currentPage: props.currentPage,
      forward: props.forward,
      position: props.sectionData.focalPoint,
      disableKeyNavigation: state.popoverIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(SectionPage, {
          id: `${props.currentSection}-1`,
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TextCard, {
                text: _unref(sectionText).willowbrook,
                enclosed: true,
                class: "md:mx-200px"
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        }, 8, ["id"]),
        _createVNode(SectionPage, {
          id: `${props.currentSection}-2`,
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(TextCard, {
              text: _unref(sectionText).card,
              class: "md:mx-200px",
              enclosed: true
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["id"]),
        _createVNode(SectionPage, {
          id: `${props.currentSection}-3`,
          class: "bg-slateGray pointer-events-none",
          style: _normalizeStyle({
          opacity:
            props.currentSection == _unref(MJPSection).History && props.currentPage == 2
              ? 1
              : 0,
        })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(sectionText).clickTheYears), 1),
            (props.currentPage == 2)
              ? (_openBlock(), _createBlock(SiteTimeline, {
                  key: 0,
                  sectionData: props.sectionData,
                  currentSection: props.currentSection,
                  thisSection: props.sectionData.section,
                  currentSectionHasLoaded: props.currentSectionHasLoaded,
                  data: _unref(timelineData),
                  active: props.currentPage == 2
                }, null, 8, ["sectionData", "currentSection", "thisSection", "currentSectionHasLoaded", "data", "active"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["id", "style"])
      ]),
      _: 1
    }, 8, ["thisSection", "currentSection", "currentSectionHasLoaded", "currentPage", "forward", "position", "disableKeyNavigation"])
  ]))
}
}

})